import { BaseType } from '../base/base-type';

export class RemittanceStatusType extends BaseType {}
